import { faLock } from '@fortawesome/pro-regular-svg-icons/faLock';
import useIsAdmin from '@maxpreps/shared/hooks/useIsAdmin';
import THEME from '@maxpreps/shared/styles/colors';
import Icon from '@maxpreps/shared/ui/Icon/Icon';
import styled from 'styled-components';

const StyledAdminOnlyCallout = styled.div`
  font-size: 11px;
  letter-spacing: 1.5px;
  background: ${THEME.surface.tertiary};
  color: ${THEME.text.tertiary};
  padding: 4px 8px;
  border-radius: 12px;
`;

const AdminOnlyBadge: React.FC = () => {
  const isAdmin = useIsAdmin();

  // We only want to show this on non admin pages.
  if (isAdmin) {
    return null;
  }

  return (
    <StyledAdminOnlyCallout>
      <Icon
        icon={faLock}
        size={12}
        // @ts-ignore
        $marginRight="2px"
      />
      ADMIN ONLY
    </StyledAdminOnlyCallout>
  );
};

export default AdminOnlyBadge;
